import plugin from 'tailwindcss/plugin';

const removeAlpha = (themeColor) => themeColor.replace(' / <alpha-value>', '');

export default plugin(({ addUtilities, colors, theme }) => {
  addUtilities({
    '.basis-input-md': {
      flexBasis: theme('flexBasis.80'),
    },
    '.bg-input': {
      backgroundColor: theme('colors.white'),
    },
    '.border-input': {
      borderColor: theme('colors.grey.250'),
    },
    '.border-input-error': {
      borderColor: theme('colors.red.500'),
    },
    '.h-input-md': {
      height: theme('height.11'),
    },
    '.px-input-md': {
      paddingLeft: theme('padding.4'),
      paddingRight: theme('padding.4'),
    },
    '.rounded-input-md': {
      borderRadius: theme('borderRadius.lg'),
    },
    '.rounded-r-input-md': {
      borderTopRightRadius: theme('borderRadius.lg'),
      borderBottomRightRadius: theme('borderRadius.lg'),
    },
    '.shadow-input': {
      boxShadow: `0 0 0 .125rem ${removeAlpha(theme('colors.primary.400'))}`,
    },
    '.shadow-input-error': {
      boxShadow: `0 0 0 .125rem ${theme('colors.red.500')}`,
    },
    '.text-input': {
      color: theme('colors.grey.800'),
    },
  });
});
